import { ReactNode } from 'react'

import classNames from 'classnames'

import styles from './index.module.css'

export interface ChipProps {
  children: string | ReactNode
  active?: boolean
  icon?: React.ReactNode
  highlight?: boolean
  highlightCustomClass?: string
  activeCustomClass?: string
  onClick?: () => void
  [key: string]: any
}

/**
 * Element that represents an input, attribute, or action
 */
const Chip = ({
  children,
  active = false,
  icon,
  highlight = false,
  highlightCustomClass = '',
  activeCustomClass = '',
  onClick,
  ...rest
}: ChipProps) => {
  const wrapper = highlight
    ? [styles.chipWrapper, styles.highlight, highlightCustomClass]
    : [styles.chipWrapper]

  return (
    <div
      className={classNames([
        {
          [activeCustomClass.length > 0
            ? activeCustomClass
            : 'border-3 border-brand-main p-2.25']: active,
        },
        ...wrapper,
      ])}
      onClick={onClick}
      {...rest}
    >
      {icon}
      {children}
    </div>
  )
}

export default Chip
